import { Leaf, Flame, Map, Moon, Gem, Dumbbell, Repeat, Shield, TrendingUp } from "lucide-react";

// Shared field set for the 8 "standard" Deep Within buckets. Each bucket's
// primary field is named after the bucket (belief / fear / …) and its reframe
// field is `new_<primary>`. The optional metadata fields are identical.
const STANDARD_META = ["frequency", "origin", "body_location", "physical_pain", "applied_practice"];

// key → config. `slug` is the URL segment under /app/within/:slug.
export const DW_CATEGORIES = {
  beliefs: {
    slug: "beliefs", endpoint: "/beliefs", bucket: "belief",
    primary: "belief", newField: "new_belief", schema: "standard", hasWeva: true,
    icon: Leaf, accent: "#79A08C",
  },
  fears: {
    slug: "fears", endpoint: "/fears", bucket: "fear",
    primary: "fear", newField: "new_fear", schema: "standard", hasWeva: true,
    icon: Flame, accent: "#6C9E9E",
  },
  surroundings: {
    slug: "surroundings", endpoint: "/surroundings", bucket: "surrounding",
    primary: "surrounding", newField: "new_surrounding", schema: "standard", hasWeva: true,
    icon: Map, accent: "#679AAA",
  },
  dreams: {
    slug: "dreams", endpoint: "/dreams", bucket: "dream",
    primary: "dream", newField: "new_dream", schema: "standard", hasWeva: true,
    icon: Moon, accent: "#6690B4",
  },
  values: {
    slug: "values", endpoint: "/values", bucket: "value",
    primary: "value", newField: "new_value", schema: "standard", hasWeva: true,
    icon: Gem, accent: "#6D82B4",
  },
  strengths: {
    slug: "strengths", endpoint: "/strengths", bucket: "strength",
    primary: "strength", newField: "new_strength", schema: "standard", hasWeva: true,
    icon: Dumbbell, accent: "#7A78B0",
  },
  habits: {
    slug: "habits", endpoint: "/habits", bucket: "habit",
    primary: "habit", newField: "new_habit", schema: "standard", hasWeva: true,
    icon: Repeat, accent: "#8578A8",
  },
  boundaries: {
    slug: "boundaries", endpoint: "/boundaries", bucket: "boundary",
    primary: "boundary", newField: "new_boundary", schema: "standard", hasWeva: true,
    icon: Shield, accent: "#8B78A0",
  },
  "upper-limits": {
    slug: "upper-limits", endpoint: "/upper-limits", bucket: "upper_limit",
    primary: "title", newField: null, schema: "upper", hasWeva: false,
    icon: TrendingUp, accent: "#877B98",
  },
};

export const DW_ORDER = [
  "beliefs", "fears", "surroundings", "dreams", "values",
  "strengths", "habits", "boundaries", "upper-limits",
];

export const STANDARD_META_FIELDS = STANDARD_META;
export const UPPER_FIELDS = ["life_area", "symptoms", "core_false_belief", "zone_of_genius_impact", "trigger", "frequency"];
